const prefix = 'features/smart-route';

export const SET_SMART_ROUTE = `${prefix}/SET_SMART_ROUTE`;
export const SET_TO_DEFAULT = `${prefix}/SET_TO_DEFAULT`;
